// import { dataType as types } from '../../constants/data-type';
// import { IPO_STATUS } from '../../constants/ipo-status';
// import { formatFunctions } from './formatFunction';
// import { utilsFunction } from '@/helpers/functions'
import { store } from '@/configurations'
import { getSafe } from '../../../../helpers/global';

export const Comparator = {
    comparatorByEventType,
    numberComparator,
    multipleComparator,
    comparatorByTimeRemainIPO
}

function comparatorByEventType(a, b) {
    const language = getSafe(() => store.getState().app.language, {});
    if (language[`ca_event_${a}`] === language[`ca_event_${b}`]) {
        return 0;
    }
    return (language[`ca_event_${a}`] > language[`ca_event_${b}`]) ? 1 : -1;
}

function numberComparator(a, b) {
    return parseFloat(a) - parseFloat(b);
}

function multipleComparator(a, b) {
    // TO DO
}

function comparatorByTimeRemainIPO(valueA, valueB, nodeA, nodeB) {
    if (parseInt(nodeA.data.remainDays) === 0 && parseInt(nodeA.data.remainHours) === 0) {
        valueA = Number.MAX_VALUE;
    }
    else {
        valueA = parseInt(nodeA.data.remainDays) * 24 + parseInt(nodeA.data.remainHours);
    }

    if (parseInt(nodeB.data.remainDays) === 0 && parseInt(nodeB.data.remainHours) === 0) {
        valueB = Number.MAX_VALUE;
    }
    else {
        valueB = parseInt(nodeB.data.remainDays) * 24 + parseInt(nodeB.data.remainHours);
    }

    return valueA > valueB ? 1 : -1;
}